import React, { useEffect, useState } from 'react';
import axios from '../../plugins/axios'
import Toast from '../../plugins/useToast'
import Dropdown from './components/Dropdown';
import i18n from '../../locales/i18n'
import { useRecoilState } from 'recoil';
import { unitState } from '../../plugins/recoil';
import { useTranslation } from 'react-i18next';

import {ReactComponent as IconClose} from '../../assets/icons/ic-close.svg'

const UserSettingModal = ({ onClose }) => {
    const { t } = useTranslation()
    const [units, setUnits] = useRecoilState(unitState)
    const [activeTab, setActiveTab] = useState('unit')
    const [isDisabled, setIsDisabled] = useState(true)
    const [oldInfo, setOldInfo] = useState({
        nibpUnit: 'mmHg',
        ibpUnit: 'mmHg',
        co2Unit: 'percent',
        tempUnit: 'celsius',
        gasUnit: 'volume',
        heightUnit: 'centimeter',
        weightUnit: 'killogram',
        monitor: 'general',
        lang: 'en'
    })
    const [ids, setIds] = useState({})

    const [nibpUnit, setNibpUnit] = useState({ label: 'mmHg', value: 'mmHg' })
    const [ibpUnit, setIbpUnit] = useState({ label: 'mmHg', value: 'mmHg' })
    const [co2Unit, setCo2Unit] = useState({ label: '%', value: 'percent' })
    const [tempUnit, setTempUnit] = useState({ label: '°C', value: 'celsius' })
    const [gasUnit, setGasUnit] = useState({ label: 'vol%', value: 'volume' })

    const nibpUnitArr = [
        { label: 'mmHg', value: 'mmHg' }, { label: 'kPa', value: 'kPa' }
    ]
    const ibpUnitArr = [
        { label: 'mmHg', value: 'mmHg' }, { label: 'kPa', value: 'kPa' }
    ]
    const co2UnitArr = [
        { label: 'mmHg', value: 'mmHg' }, { label: '%', value: '%' }, { label: 'kPa', value: 'kPa' }
    ]
    const tempUnitArr = [
        { label: '°C', value: '°C' }, { label: '°F', value: '°F' }
    ]
    const gasUnitArr = [
        { label: 'mmHg', value: 'mmHg' }, { label: 'kPa', value: 'kPa' }, { label: 'vol%', value: 'vol%' }
    ]

    const [dropdownStates, setDropdownStates] = useState({
        nibp: false,
        ibp: false,
        co2: false,
        temp: false,
        gas: false,
        lang: false,
      });
    
    const [monitor, setMonitor] = useState('general')
    const [isLangDropdownShow, setIsLangDropdownShow] = useState(false)
    const [lang, setLang] = useState({ label: 'English', value: 'en' })
    const langArr = [
        { label: 'English', value: 'en' }, { label: '한국어', value: 'ko' },
        { label: 'Polish', value: 'pl' }, { label: 'Italian', value: 'it' },
    ]

    const handleClickDropdown = (type, val) => {
        setDropdownStates(prev => ({
            ...prev,
            [type]: typeof val !== 'undefined' ? false : !prev[type],
        }));
    }

    const getUserSettings = async () => {
        try {
            let res
            switch(activeTab) {
                case 'unit':
                    res = await axios.get('/measure/parameter/categories')
                    if (res.code != '200') throw res
                    const data = res.data.categories
                    
                    const nibpInfo = data.find(category => category.name === 'NIBP')
                    const nibpUnit = nibpUnitArr.find(unit => unit.value === (nibpInfo.unit ? nibpInfo.unit : nibpInfo.defaultUnit))
                    setNibpUnit(nibpUnit)

                    const ibpInfo = data.find(category => category.name === 'IBP')
                    const ibpUnit = ibpUnitArr.find(unit => unit.value === (ibpInfo.unit ? ibpInfo.unit : ibpInfo.defaultUnit))
                    setIbpUnit(ibpUnit)

                    const co2Info = data.find(category => category.name === 'CO2')
                    const co2Unit = co2UnitArr.find(unit => unit.value === (co2Info.unit ? co2Info.unit : co2Info.defaultUnit))
                    setCo2Unit(co2Unit)

                    const tempInfo = data.find(category => category.name === 'TEMP')
                    const tempUnit = tempUnitArr.find(unit => unit.value === (tempInfo.unit ? tempInfo.unit : tempInfo.defaultUnit))
                    setTempUnit(tempUnit)

                    const gasInfo = data.find(category => category.name === 'GAS')
                    const gasUnit = gasUnitArr.find(unit => unit.value === (gasInfo.unit ? gasInfo.unit : gasInfo.defaultUnit))
                    setGasUnit(gasUnit)

                    setUnits({
                        ...units,
                        'NIBP': nibpUnit.value,
                        'IBP': ibpUnit.value,
                        'IBP1': ibpUnit.value,
                        'IBP2': ibpUnit.value,
                        'IBP3': ibpUnit.value,
                        'IBP4': ibpUnit.value,
                        'EtCO2': co2Unit.value,
                        'InCO2': co2Unit.value,
                        'Temp': tempUnit.value,
                        'Temp1': tempUnit.value,
                        'Temp2': tempUnit.value,
                        'GAS': gasUnit.value
                    })

                    setIds({
                        nibp: nibpInfo.id,
                        ibp: ibpInfo.id,
                        co2: co2Info.id,
                        temp: tempInfo.id,
                        gas: gasInfo.id
                    })

                    setOldInfo(prev => ({
                        ...prev,
                        nibpUnit: nibpUnit.value,
                        ibpUnit: ibpUnit.value,
                        co2Unit: co2Unit.value,
                        tempUnit: tempUnit.value,
                        gasUnit: gasUnit.value
                    }))
                    break;
                case 'language':
                    res = await axios.get('/user/me')
                    if (res.code != '200') throw res
                    setLang(langArr.find(langItem => langItem.value === res.data.language) || { label: 'English', value: 'en' })
                    setOldInfo(prev => ({ ...prev, lang: res.data.language }))
                    break;
            }
            setIsDisabled(true)
        } catch (err) {
            console.warn(err);
        }
    };    

    // 저장 성공
    const handleSave = async () => {
        try {
            let res
            switch(activeTab) {
                case 'unit':
                    res = await axios.put(`/measure/parameter/categories/unit`, { categories: Object.keys(ids).map(key => {
                        let targetUnit
                        switch(key) {
                            case 'nibp':
                                targetUnit = nibpUnit.value; break;
                            case 'ibp':
                                targetUnit = ibpUnit.value; break;
                            case 'co2':
                                targetUnit = co2Unit.value; break;
                            case 'temp':
                                targetUnit = tempUnit.value; break;
                            case 'gas':
                                targetUnit = gasUnit.value; break;
                        }
                        return {
                            id: ids[key],
                            unit: targetUnit
                        }
                    })})
                    if (res.code != '200') throw res
                    setUnits({
                        ...units,
                        'NIBP': nibpUnit.value,
                        'IBP': ibpUnit.value,
                        'IBP1': ibpUnit.value,
                        'IBP2': ibpUnit.value,
                        'IBP3': ibpUnit.value,
                        'IBP4': ibpUnit.value,
                        'EtCO2': co2Unit.value,
                        'InCO2': co2Unit.value,
                        'Temp': tempUnit.value,
                        'Temp1': tempUnit.value,
                        'Temp2': tempUnit.value,
                        'GAS': gasUnit.value
                    })
                    setOldInfo(prev => ({
                        ...prev,
                        nibpUnit: nibpUnit.value,
                        ibpUnit: ibpUnit.value,
                        co2Unit: co2Unit.value,
                        tempUnit: tempUnit.value,
                        gasUnit: gasUnit.value
                    }))
                    break;
                case 'language':
                    res = await axios.patch(`/user/me/language`, { language: lang.value })
                    if (res.code != '200') throw res
                    i18n.changeLanguage(lang.value)
                    localStorage.setItem('lang', lang.value)
                    setOldInfo(prev => ({ ...prev, lang: lang.value }))
                    break;
            }
            setIsDisabled(true)
            Toast({ isSuccess: true })
        } catch (err) {
            Toast({ isSuccess: false, msg: err.message || t('userSettings.retryLater') })
        }
    };

    useEffect(() => {
        if (activeTab === 'unit') {
            if (!nibpUnit || !ibpUnit || !co2Unit || !tempUnit || !gasUnit || !oldInfo) {
                return;
            }
            if (nibpUnit.value !== oldInfo.nibpUnit ||
                ibpUnit.value !== oldInfo.ibpUnit ||
                co2Unit.value !== oldInfo.co2Unit ||
                tempUnit.value !== oldInfo.tempUnit ||
                gasUnit.value !== oldInfo.gasUnit 
            ) {
                setIsDisabled(false)
            } else {
                setIsDisabled(true)
            }
        } else if (activeTab === 'language') {
            if (lang.value !== oldInfo.lang) {
                setIsDisabled(false)
            } else {
                setIsDisabled(true)
            }
        }
    }, [activeTab, nibpUnit, ibpUnit, co2Unit, tempUnit, gasUnit, monitor, lang])

    useEffect(() => {
        getUserSettings();        
    }, [activeTab]);

    return (
        <div className="relative w-full h-full bg-black max-h-[520px] font-normal border-t border-white">
            <div className="bg-[#1F1F1F] w-full h-full">
                <div className="flex justify-between items-center h-[32px]">
                    <h2 className="text-lg font-normal text-[white] m-[6px] ml-5">{t('userSettings.title')}</h2>
                    <div className="flex items-center">
                        <button className={`w-[88px] h-[28px] absolute top-[3px] right-[40px] rounded-[6px] font-light
                                ${isDisabled? ' bg-[#282828] text-[rgba(255,255,255,0.2)] cursor-default shadow-none'
                                : ' text-white bg-gradient-to-b from-[#5E5E5E] to-[#383838] shadow-md transition-all duration-200'}
                                active:from-[#4A4A4A] active:to-[#2B2B2B] active:shadow-sm`}
                            disabled={isDisabled}
                            onClick={() => { handleSave() }}
                            data-testid={isDisabled ? 'saved-btn' : 'save-btn'}
                            aria-label={isDisabled ? 'Saved' : 'Save'}
                        >
                            {isDisabled ? t('userSettings.saved') : t('userSettings.save')}
                        </button>
                        <IconClose onClick={() => { onClose() }} className="m-[10px] cursor-pointer"/>
                    </div>
                </div>
                <div className="text-white flex" style={{ height: 'calc(100% - 32px)' }}>
                    <div className="bg-[#2F2F2F] px-3 py-5 w-[284px] h-full" style={{ fontSize: 18 }}>
                        <div className="h-[40px] flex items-center cursor-pointer" onClick={() => { setActiveTab('unit') }} style={{ padding: '10px 11px', background: activeTab === 'unit' ? '#1F1F1F' : '', boxShadow: `inset ${activeTab === 'unit' ? '2px' : '0'} 0 0 #3182F7` }}>{t('userSettings.unit')}</div>
                        <div className="h-[40px] flex items-center cursor-pointer" onClick={() => { setActiveTab('language') }} style={{ padding: '10px 11px', background: activeTab === 'language' ? '#1F1F1F' : '', boxShadow: `inset ${activeTab === 'language' ? '2px' : '0'} 0 0 #3182F7` }}>{t('userSettings.language')}</div>
                    </div>
                    <div className='relative w-full h-full'>
                        <div className="flex overflow-y-auto scrollbar" style={{ height: 'calc(100%)' }}>
                            {                        
                                activeTab === 'unit' &&
                                <div className="px-10 py-5">
                                    <div className="" style={{ fontSize: 18 }}>{t('userSettings.unitConfiguration')}</div>
                                    <div className="mt-3">
                                        <div className="font-light mb-1">NIBP</div>
                                        <Dropdown 
                                            type={'nibp'}
                                            isShow={dropdownStates.nibp}
                                            value={nibpUnit}
                                            valueArr={nibpUnitArr}
                                            handleClick={(val) => handleClickDropdown('nibp', val)}
                                            handleValueClick={(val) => { setNibpUnit(val) }}
                                        />
                                    </div>
                                    <div className="mt-3">
                                        <div className="font-light mb-1">IBP</div>
                                        <Dropdown 
                                            type={'ibp'}
                                            isShow={dropdownStates.ibp}
                                            value={ibpUnit}
                                            valueArr={ibpUnitArr}
                                            handleClick={(val) => handleClickDropdown('ibp', val)}
                                            handleValueClick={(val) => { setIbpUnit(val) }}
                                        />
                                    </div>
                                    <div className="mt-3">
                                        <div className="font-light mb-1">CO2</div>
                                        <Dropdown 
                                            type={'co2'}
                                            isShow={dropdownStates.co2}
                                            value={co2Unit}
                                            valueArr={co2UnitArr}
                                            handleClick={(val) => handleClickDropdown('co2', val)}
                                            handleValueClick={(val) => { setCo2Unit(val) }}
                                        />
                                    </div>
                                    <div className="mt-3">
                                        <div className="font-light mb-1">{t('userSettings.temperature')}</div>
                                        <Dropdown 
                                            type={'temp'}
                                            isShow={dropdownStates.temp}
                                            isUpSide={true}
                                            value={tempUnit}
                                            valueArr={tempUnitArr}
                                            handleClick={(val) => handleClickDropdown('temp', val)}
                                            handleValueClick={(val) => { setTempUnit(val) }}
                                        />
                                    </div>
                                    <div className="mt-3">
                                        <div className="font-light mb-1">Gas</div>
                                        <Dropdown 
                                            type={'gas'}
                                            isShow={dropdownStates.gas}
                                            value={gasUnit}
                                            isUpSide={true}
                                            valueArr={gasUnitArr}
                                            handleClick={(val) => handleClickDropdown('gas', val)}
                                            handleValueClick={(val) => { setGasUnit(val) }}
                                        />
                                    </div>
                                </div>
                            }
                            {
                                activeTab === 'language' &&
                                <div className="px-10 py-5">
                                    <div className="" style={{ fontSize: 18 }}>{t('userSettings.languageSettings')}</div>
                                    <div className="mt-3">
                                        <div className="font-light mb-1">{t('userSettings.language')}</div>
                                        <Dropdown 
                                            type={'lang'}
                                            isShow={dropdownStates.lang}
                                            value={lang}
                                            valueArr={langArr}
                                            handleClick={(val) => handleClickDropdown('lang', val)}
                                            handleValueClick={(val) => { setLang(val) }}
                                        />
                                    </div>
                                </div>
                            }
                        </div>                        
                    </div>                    
                </div>
            </div>
        </div>
    );
};


export default UserSettingModal;
